var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000092"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff00f3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 1.5,
    x2: 28,
    y1: 16.5,
    y2: 16.5,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M14.877 1.998V2h-.043c-.733.02-1.351.57-1.455 1.297l-.158 1.1a12.458 12.458 0 0 0-3.813 1.58l-.89-.666a1.517 1.517 0 0 0-1.977.142L4.955 7.04a1.52 1.52 0 0 0-.143 1.977l.663.886a12.46 12.46 0 0 0-1.586 3.82l-1.09.155a1.52 1.52 0 0 0-1.299 1.5v2.246c0 .748.558 1.39 1.299 1.496l1.097.158c.312 1.353.844 2.64 1.58 3.817l-.665.888a1.52 1.52 0 0 0 .142 1.979l1.586 1.582c.53.53 1.377.595 1.977.146l.884-.662a12.461 12.461 0 0 0 3.823 1.584l.156 1.092c.106.742.749 1.3 1.498 1.299h2.244a1.52 1.52 0 0 0 1.496-1.299l.158-1.098a12.47 12.47 0 0 0 3.819-1.585l.787.591c.66.494 1.59.425 2.172-.158l1.494-1.492a1.52 1.52 0 0 0 .142-1.979l-.662-.884a12.462 12.462 0 0 0 1.584-3.82l.961-.14A1.67 1.67 0 0 0 30.5 17.49v-2.113a1.52 1.52 0 0 0-1.299-1.5l-1.1-.158a12.452 12.452 0 0 0-1.58-3.813l.588-.787a1.669 1.669 0 0 0-.156-2.172L25.46 5.455a1.517 1.517 0 0 0-1.977-.144l-.884.662a12.463 12.463 0 0 0-3.825-1.584l-.138-.961a1.67 1.67 0 0 0-1.645-1.43h-2.113zM14.861 3h2.129c.334 0 .61.24.656.57l.229 1.584.346.067c1.493.295 2.913.882 4.177 1.73l.295.197L24.08 6.11a.509.509 0 0 1 .672.05l1.494 1.493a.656.656 0 0 1 .063.866l-.965 1.287.197.295a11.498 11.498 0 0 1 1.729 4.17l.068.347 1.723.248c.256.037.44.249.439.508v2.113c0 .334-.238.611-.568.659l-1.584.228-.069.346a11.5 11.5 0 0 1-1.732 4.176l-.197.294 1.039 1.39a.507.507 0 0 1-.05.669l-1.493 1.494a.658.658 0 0 1-.867.06l-1.288-.964-.295.197a11.495 11.495 0 0 1-4.173 1.729l-.348.07-.246 1.719a.51.51 0 0 1-.508.441h-2.244a.51.51 0 0 1-.51-.441l-.244-1.711-.348-.069A11.5 11.5 0 0 1 9.6 26.04l-.295-.197-1.387 1.039a.509.509 0 0 1-.672-.049L5.66 25.244a.507.507 0 0 1-.049-.67l1.043-1.39-.197-.295a11.498 11.498 0 0 1-1.728-4.172l-.069-.348-1.72-.248a.495.495 0 0 1-.44-.498v-2.246c0-.26.183-.471.44-.508l1.712-.246.069-.348A11.501 11.501 0 0 1 6.455 10.1l.197-.293-1.039-1.389a.507.507 0 0 1 .05-.67l1.585-1.586a.51.51 0 0 1 .67-.05l1.393 1.042.293-.197a11.502 11.502 0 0 1 4.17-1.725l.347-.068.246-1.72a.51.51 0 0 1 .494-.442V3zM16 6C10.208 6 5.502 10.708 5.502 16.5S10.208 26.998 16 26.998c5.792 0 10.498-4.706 10.498-10.498C26.498 10.708 21.792 6 16 6zm0 1a9.492 9.492 0 0 1 9.498 9.5A9.49 9.49 0 0 1 16 25.998 9.49 9.49 0 0 1 6.502 16.5C6.502 11.248 10.748 7 16 7zm0 1c-4.688 0-8.5 3.812-8.5 8.5 0 4.689 3.812 8.5 8.5 8.5 4.688 0 8.5-3.811 8.5-8.5 0-4.688-3.812-8.5-8.5-8.5zm0 1c4.148 0 7.5 3.352 7.5 7.5S20.148 24 16 24a7.492 7.492 0 0 1-7.5-7.5C8.5 12.352 11.852 9 16 9zm0 1c-3.583 0-6.498 2.917-6.498 6.5A6.506 6.506 0 0 0 16 22.998a6.506 6.506 0 0 0 6.498-6.498c0-3.583-2.915-6.5-6.498-6.5zm0 1a5.492 5.492 0 0 1 5.498 5.5A5.49 5.49 0 0 1 16 21.998a5.49 5.49 0 0 1-5.498-5.498c0-3.043 2.456-5.5 5.498-5.5z",
    color: "#000",
    fontFamily: "sans-serif",
    fontWeight: 400,
    overflow: "visible",
    style: {
      lineHeight: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      blockProgression: "tb",
      isolation: "auto",
      mixBlendMode: "normal"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGear);
export default __webpack_public_path__ + "static/media/gear.4224c455df7a0cfe1db943abb98ca4c0.svg";
export { ForwardRef as ReactComponent };